// extracted by mini-css-extract-plugin
module.exports =  {"Basic":"Basic__BhGPG"};